import firebase from "../../firebase";

export default function({ officeId, persons }) {
    return firebase.functions().httpsCallable("allFunctions")({
        funcRole: "pagingAdmin",
        funcName: "addPersonsToOffice",
        data: { officeId, persons }
    });
}
